import React, { useState, useEffect} from "react";
import {collection, getDocs, addDoc} from "firebase/firestore";
import {db, stor} from "../firebase/firebaseConfig2";
import {getStorage, ref, uploadBytesResumable, getDownloadURL} from "firebase/storage";

export default function Upload(){



    const [users, setUsers] = useState([]);
    const storage = getStorage();
    const storageRef = ref(stor);





    let [progress, setProgress] = useState(0)
    let onHandleSubmit = (event) => {


        event.preventDefault();

        const file = event.target[0].files[0];
        uploadFiles(file)
    }
    let uploadFiles =( file) =>{
        //
        if (!file) return;
        const fileRef = ref(stor, `/files/${file.name}`);
        const uploadTask = uploadBytesResumable(fileRef, file);
        uploadTask.on("state_changed", (snapshot) => {
            const prog = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100 )
            setProgress(prog)
        }, (err) => console.log(err),
            () => {
            getDownloadURL(uploadTask.snapshot.ref)
                .then((url) => console.log(url))
            }
            )

    }


    return(
        <div>
            <h1 className={"About-Header"}>Upload Abstract</h1>
            <form  className={'regForm'} onSubmit={onHandleSubmit}>

            <label className={"Reg-Label"}>

                Upload Abstract:
                <br/>
                <input className={"Reg-Input"} required  placeholder={"Affiliation"} type={'file'} accept={'application/pdf'}  onChange={(event) => (event.target.value) } />
            </label>
            <br/>

            <button className={"Reg-Button"} type={"submit"}>Upload</button>

        </form>
        <h3>Uploaded {progress} %</h3>



        </div>
    )
}